import { Registration } from '../../components/ModalsManager/Modals/Registration/Registration';
import { SignInWrapper } from '../SignIn/SignIn.styled';

export const SignUp = () => {
  return (
    <SignInWrapper>
      <Registration></Registration>
    </SignInWrapper>
  );
};
